import React from 'react'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Layout, message, Modal, Button, Select } from 'antd'

import moment from 'moment'

import './styles.scss'

const { Option } = Select

class Filter extends React.Component {
  constructor(props) {
    super(props)
  }

  componentWillReceiveProps(nextProps) {
    const { selectedCloud, onCloudSelection } = nextProps
    if (selectedCloud && !this.props.selectedCloud)
      onCloudSelection(selectedCloud)
  }

  render() {
    const {
      cloudAccounts,
      onCloudSelection,
      onDateChange,
      onClearFilter,
      selectedCloud,
      selectedDate,
    } = this.props
    return (
      <div className="filter">
        <CloudAccountFilter
          cloudAccounts={cloudAccounts}
          onCloudSelection={onCloudSelection}
          selectedCloud={selectedCloud}
        />
        <div className="filter-selection">
          <DateFilter onDateChange={onDateChange} selectedDate={selectedDate} />
          {/*<Button type="primary" onClick={onClearFilter}>
                        Clear Filter
        </Button>*/}
        </div>
      </div>
    )
  }
}

const CloudAccountFilter = ({
  cloudAccounts,
  onCloudSelection,
  selectedCloud,
}) => (
  <Select
    value={selectedCloud}
    className="clouds-filter"
    onChange={onCloudSelection}
    placeholder="Cloud Account"
  >
    {cloudAccounts
      .filter(acc => {
        switch (acc.account_type_id) {
          case 'azure':
          case 'wasabi':
            return false
          default:
            return true
        }
      })
      .map(({ id, project_name }) => (
        <Option key={id} value={id}>
          {project_name}
        </Option>
      ))}
  </Select>
)

const DateFilter = ({ onDateChange, selectedDate }) => {
  const years = [0, 1, 2, 3].map(n =>
    moment()
      .subtract(n, 'years')
      .format('YYYY')
  )

  return (
    <div className="date-filter">
      <Select
        value={selectedDate.year}
        placeholder="Year"
        className="year-filter"
        onChange={year => onDateChange({ type: 'year', value: year })}
      >
        {years.map(y => (
          <Option key={y} value={y}>{y}</Option>
        ))}
      </Select>
      <Select
        value={selectedDate.month}
        placeholder="Month"
        className="month-filter"
        onChange={month => onDateChange({ type: 'month', value: month })}
      >
        {moment.months().map((m, i) => (
          <Option key={m} value={i + 1 < 10 ? `0${i + 1}` : i + 1}>{m}</Option>
        ))}
      </Select>
    </div>
  )
}

export default Filter
